// extracted by mini-css-extract-plugin
export default {"list":"pip-options-list_list__Eg90+","buttons":"pip-options-list_buttons__bmrsf","pager":"pip-options-list_pager__bvlGY"};